import axios from 'axios';
import { SERVER_URL } from '../../../../constants/ClientConfig';
import { USER_STATUS, USER_FORGOT_DETAILS, USER_GET_OTP, USER_VERIFY_OTP, USER_UPDATE_IRCTC_ID } from '../../../../constants/ActionTypes';
import {
  setItemBySession,
  itemType
} from 'MMT-UI/storages/client/sessionStorage';
import { STORAGE_CONSTANTS } from '../../../../constants/TrainConstants';
import { updateIrctcUserName } from '../../../../API/TravellerPage/TravellerPageApi';
import { isUserLoggedIn } from '../../../../utils/BizUtils';
import { generateId } from '../../../../utils/trainUtils';

export const fetchUserStatusAction = (userId) => async (dispatch) => {
  const traceId = generateId();
  try {
    const headers = {"X-Trace-Id": traceId};
    const res = await axios.get(`${SERVER_URL}/user/status/${userId}`, { headers });
    const userStatus = res.data;
    dispatch({
      type: USER_STATUS,
      payload: { userStatus },
    });
    if (!res?.data?.error) {
      dispatch({
        type: USER_UPDATE_IRCTC_ID,
        payload: res?.data?.irctcUserId,
      })
      setItemBySession(
        STORAGE_CONSTANTS.VERIFIED_USER_ID,
        userId,
        { isPiiData: true, shouldStringifyJson: true },
        itemType.ES
      );
      if (isUserLoggedIn()) {
        updateIrctcUserName(userId);
      }
    }
  } catch (error) {
    console.error(error);

  }
};

export const userForgotDetailsAction = (requestType, queryParams) => async (dispatch) => {
  const traceId = generateId();
  try {
    const headers = {"X-Trace-Id": traceId};
    const res = await axios.get(`${SERVER_URL}/user/irctc/details/${requestType}`, {
      params: {
        userLoginId: queryParams.userLoginId || '',
        email: queryParams.email || '',
        mobile: queryParams.mobile || '',
        otpType: queryParams.otpType || '',
        dob: queryParams.dob || '',
      },
    }, { headers });
    const userDetails = res.data;
    dispatch({
      type: USER_FORGOT_DETAILS,
      payload: {
        userDetails: {
          ...userDetails,
          otpType: queryParams.otpType,
          email: queryParams.email,
        }
      },
    });
  } catch (error) {
    console.error(error);
  }
};

export const userForgotDetailsActionV2 = (requestType, queryParams) => async (dispatch) => {
  const traceId = generateId();
  try {
    const headers = { "X-Trace-Id": traceId };
    const res = await axios.post(
      `${SERVER_URL}/user/irctc/detailsV2/${requestType}`,
      {
        userLoginId: queryParams.userLoginId || '',
        email: queryParams.email || '',
        mobile: queryParams.mobile || '',
        otpType: queryParams.otpType || '',
        dob: queryParams.dob || '',
      },
      { headers }
    );
    const userDetails = res.data;
    dispatch({
      type: USER_FORGOT_DETAILS,
      payload: {
        userDetails: {
          ...userDetails,
          otpType: queryParams.otpType,
          email: queryParams.email,
        }
      },
    });
  } catch (error) {
    console.error(error);
  }
};

export const getOtpAction = (userId, otpType) => async (dispatch) => {
  const traceId = generateId();
  try {
    const headers = {"X-Trace-Id": traceId};
    const res = await axios.get(`${SERVER_URL}/user/getOtp/${userId}/${otpType}`, { headers });
    const getOtpResponse = res.data;
    dispatch({
      type: USER_GET_OTP,
      payload: { getOtpResponse },
    });
  } catch (error) {
    console.error(error);
  }
};

export const verifyOtpAction = (userId, otpType, queryParams) => async (dispatch) => {
  const traceId = generateId();
  try {
    const headers = {"X-Trace-Id": traceId};
    const res = await axios.get(`${SERVER_URL}/user/verifyOtp/${userId}/${otpType}`, {
      params: {
        emailCode: queryParams.emailCode || '',
        smsCode: queryParams.smsCode || '',
      },
    }, { headers });
    const verifyOtpResponse = res.data;
    dispatch({
      type: USER_VERIFY_OTP,
      payload: { verifyOtpResponse },
    });
  } catch (error) {
    console.error(error);
  }
};
